export default "public/1SFA611930R1252.svg";